/**
 * Rest screen (campfire). The engine's rest reducer heals a % of max HP. We
 * surface that as the primary action; a future "smith" (upgrade a card) can be
 * added here using the engine's upgradeCard reducer.
 */

import { el, div, button } from "../dom";
import { topbar } from "../widgets";
import { heatModifiers } from "../../engine";
import type { Store } from "../store";

export function renderRest(store: Store): HTMLElement {
  const run = store.run!;
  const heat = heatModifiers(run.heat);
  const heal = Math.max(0, Math.floor(run.maxHp * 0.3 * heat.restHealMult));

  const screen = div("screen");
  screen.appendChild(topbar(run, () => store.open("deck")));

  const body = div("screen__body");
  body.style.alignItems = "center";
  body.style.justifyContent = "center";
  body.style.gap = "16px";

  body.appendChild(el("div", { class: "logo", text: "♨", style: "font-size:72px" }));
  body.appendChild(el("div", { class: "h-title", text: "REST SITE" }));
  body.appendChild(
    el("div", {
      class: "muted center",
      style: "max-width:420px;white-space:normal;line-height:1.5",
      text: "A safe node off the grid. Patch yourself before pressing deeper — but the Trace never truly forgets.",
    }),
  );

  const panel = div("panel panel--raised col");
  panel.style.alignItems = "center";
  panel.style.minWidth = "320px";
  panel.appendChild(
    el("div", {
      class: "h-sub",
      text: `REPAIR  +${heal} HP`,
      style: "color:var(--ink-max)",
    }),
  );
  panel.appendChild(
    el("div", { class: "muted", text: `${run.hp} / ${run.maxHp} → ${Math.min(run.maxHp, run.hp + heal)} / ${run.maxHp}` }),
  );
  panel.appendChild(
    button("btn btn--primary", "REST ▶", () => store.rest()),
  );
  body.appendChild(panel);

  screen.appendChild(body);
  screen.appendChild(
    div("keyhints", [
      el("span", {}, [el("kbd", { text: "Enter" }), " rest"]),
      el("span", {}, [el("kbd", { text: "V" }), " deck"]),
    ]),
  );
  return screen;
}

/** Keyboard for rest. */
export function restKey(store: Store, key: string): boolean {
  if (!store.run || store.run.phase !== "rest") return false;
  if (key === "Enter") {
    store.rest();
    return true;
  }
  if (key.toLowerCase() === "v") {
    store.open("deck");
    return true;
  }
  return false;
}
